module.exports = __webpack_public_path__ + "img/banner_pc.e8337a6b.png";